'use client';

import { useContext } from 'react';

import { AuthorLevelsApplicationContext } from '@/features/original-plus/context/author-levels-application-context';

export function useAuthorLevelsApplication() {
  const context = useContext(AuthorLevelsApplicationContext);
  if (!context) {
    throw new Error(
      'useAuthorLevelsApplication must be used within AuthorLevelsApplicationProvider',
    );
  }
  return context;
}
